import React, {useState} from 'react';

import EntryCard from '../../../react4xp/components/EntryCard'
import Section from '../../../react4xp/components/Section'

function EntryCardPart(props) {
	return (
		<Section bgColor={props.sectionBgColor}>
			<EntryCard 
				tag={props.tagline}
				title={props.title}
				content={{
					text: props.text,
				}}
				cta={props.cta}
				img={props.image}
				imgLarge={props.imageLarge}
				orientation={props.cardAlignment}
				imageAsBackground={props.imageAsBackground}
				backgroundColor={props.bgColor}
				contentColor={'primary'}
			/>
		</Section>
	)
}

export default (props) => <EntryCardPart {...props} />
